/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { __decorate } from "tslib";
import { LitElement } from 'lit';
import { property } from '../decorators/property.js';
import { active } from '../controllers/active.controller.js';
import { ariaPopupTrigger } from '../controllers/aria-popup-trigger.controller.js';
import { ariaDisabled } from '../controllers/aria-disabled.controller.js';
import { ariaPressed } from '../controllers/aria-pressed.controller.js';
import { ariaButton } from '../controllers/aria-button.controller.js';
import { buttonAnchor } from '../controllers/button-anchor.controller.js';
import { buttonSubmit } from '../controllers/button-submit.controller.js';
import { ariaExpanded } from '../controllers/aria-expanded.controller.js';
/**
 * Base class that provides all nessesary behavior for enabling a custom element to emulate a native button.
 */
let CdsBaseButton = class CdsBaseButton extends LitElement {
    constructor() {
        super(...arguments);
        this._disabled = false;
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        const oldValue = this._disabled;
        this._disabled = value;
        this.requestUpdate('disabled', oldValue);
    }
};
__decorate([
    property({ type: Boolean })
], CdsBaseButton.prototype, "pressed", void 0);
__decorate([
    property({ type: Boolean })
], CdsBaseButton.prototype, "expanded", void 0);
__decorate([
    property({ type: Boolean })
], CdsBaseButton.prototype, "readonly", void 0);
__decorate([
    property({ type: String })
], CdsBaseButton.prototype, "type", void 0);
__decorate([
    property({ type: String })
], CdsBaseButton.prototype, "name", void 0);
__decorate([
    property({ type: String })
], CdsBaseButton.prototype, "value", void 0);
__decorate([
    property({ type: Boolean })
], CdsBaseButton.prototype, "disabled", null);
__decorate([
    property({ type: String })
], CdsBaseButton.prototype, "popup", void 0);
CdsBaseButton = __decorate([
    active(),
    ariaButton(),
    ariaPressed(),
    ariaExpanded(),
    ariaDisabled(),
    ariaPopupTrigger(),
    buttonSubmit(),
    buttonAnchor()
], CdsBaseButton);
export { CdsBaseButton };
